"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37682,16570,25201,90717],{

/***/ 16570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-3-2v4M8 2v4m-5 4h18",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCalendar);

/***/ }),

/***/ 25201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgList = function SvgList(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgList);

/***/ }),

/***/ 38928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgX = function SvgX(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18 6 6 18M6 6l12 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgX);

/***/ }),

/***/ 90717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ instant_search; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/hooks/useInstantSearch.js + 2 modules
var useInstantSearch = __webpack_require__(69887);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/components/InstantSearch.js + 33 modules
var InstantSearch = __webpack_require__(42704);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(70290);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 4 modules
var debounce = __webpack_require__(8891);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(79080);
// EXTERNAL MODULE: ./components/algolia/utils.ts
var utils = __webpack_require__(93743);
;// CONCATENATED MODULE: ./components/algolia/instant-search/InstantSearch.tsx







var _NEXT_PUBLIC_ALGOLIA_SEARCH_APP_ID, _NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY;
const algoliaClient = algoliasearch_lite_umd_default()((_NEXT_PUBLIC_ALGOLIA_SEARCH_APP_ID = "CPIZ75VUWI") !== null && _NEXT_PUBLIC_ALGOLIA_SEARCH_APP_ID !== void 0 ? _NEXT_PUBLIC_ALGOLIA_SEARCH_APP_ID : "", (_NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY = "1f15995e8acacfed3ad514430336ffb8") !== null && _NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY !== void 0 ? _NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY : "");
function gtmMiddleware(results) {
    const sendEventDebounced = (0,debounce/* default */.Z)((uiState)=>{
        const indexName = Object.keys(uiState)[0];
        const searchQuery = uiState[indexName].query;
        if (searchQuery) {
            if (results.nbHits === 0) {
                (0,helpers/* gtmPush */.De)({
                    event: "search_unavailable",
                    search_term: searchQuery
                });
            } else {
                (0,helpers/* gtmPush */.De)({
                    event: "search",
                    search_term: searchQuery,
                    search_results_count: results.nbHits,
                    search_results: results.hits.map((hit)=>({
                            item_id: (0,utils/* convertToURL */.Mh)(hit.objectID.replaceAll(" > ", "/")),
                            item_name: hit.name
                        }))
                });
            }
        }
    }, 3000);
    return {
        onStateChange (param) {
            let { uiState  } = param;
            sendEventDebounced(uiState);
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        subscribe () {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        unsubscribe () {}
    };
}
function Middleware() {
    const { use , results  } = (0,useInstantSearch/* useInstantSearch */.b)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,compat_module.useEffect)(()=>use(()=>gtmMiddleware(results)));
    return null;
}
/**
 * InstantSearch
 */ const InstantSearch_InstantSearch = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime/* jsxs */.BX)(InstantSearch/* InstantSearch */.p, {
        searchClient: algoliaClient,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Middleware, {})
        ]
    });
};
InstantSearch_InstantSearch.displayName = "InstantSearch";

;// CONCATENATED MODULE: ./components/algolia/instant-search/index.ts

/* harmony default export */ var instant_search = (InstantSearch_InstantSearch);


/***/ }),

/***/ 58452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pagination; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/light/chevron-left.svg
var chevron_left = __webpack_require__(30282);
// EXTERNAL MODULE: ./components/icons/light/chevron-right.svg
var chevron_right = __webpack_require__(14649);
;// CONCATENATED MODULE: ./components/molecules/pagination/Pagination.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex flex-row items-center gap-3 \n      ",
        "  \n      ",
        "\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const Pagination = (param)=>/*#__PURE__*/ {
    let { className ="" , disabled =false , onPageChange , pageRangeDisplayed =2 , pageCount , renderOnZeroPageCount =()=>null  } = param;
    return (0,jsx_runtime/* jsx */.tZ)((react_paginate_default()), {
        previousLabel: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_left["default"], {
            width: 24,
            height: 24,
            className: "flex flex-row items-center gap-3 text-neutrals-900"
        }),
        nextLabel: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_right["default"], {
            width: 24,
            height: 24,
            className: "flex flex-row items-center gap-3 text-neutrals-900"
        }),
        pageClassName: "flex flex-row gap-3 items-center justify-center p-1 text-center h-10 w-10 text-body text-body--l [&_a]:text-text-neutrals-900",
        activeClassName: "flex flex-row gap-3 items-center bg-secondary-500 rounded-lg text-secondary-900 text-body text-body--l cursor-pointer",
        disabledClassName: "pointer-events-none text-neutrals-300 opacity-40",
        onPageChange: onPageChange,
        pageRangeDisplayed: pageRangeDisplayed,
        pageCount: pageCount,
        renderOnZeroPageCount: renderOnZeroPageCount,
        marginPagesDisplayed: 0,
        breakLabel: null,
        className: (0,es/* oneLine */.f9)(_templateObject(), disabled ? "pointer-events-none opacity-40" : "", className)
    });
};
Pagination.displayName = "Pagination";

;// CONCATENATED MODULE: ./components/molecules/pagination/index.ts

/* harmony default export */ var pagination = (Pagination);


/***/ }),

/***/ 37682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ list_of_flats; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/components/InstantSearchSSRProvider.js
var InstantSearchSSRProvider = __webpack_require__(37966);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/components/Configure.js + 2 modules
var Configure = __webpack_require__(94333);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/light/calendar.svg
var calendar = __webpack_require__(16570);
// EXTERNAL MODULE: ./components/icons/light/chevron-left.svg
var chevron_left = __webpack_require__(30282);
// EXTERNAL MODULE: ./components/icons/light/chevron-right.svg
var chevron_right = __webpack_require__(14649);
// EXTERNAL MODULE: ./components/icons/light/list.svg
var list = __webpack_require__(25201);
// EXTERNAL MODULE: ./components/icons/light/map-pin.svg
var map_pin = __webpack_require__(80266);
// EXTERNAL MODULE: ./components/icons/light/x.svg
var x = __webpack_require__(38928);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(42648);
// EXTERNAL MODULE: ./components/algolia/instant-search/index.ts + 1 modules
var instant_search = __webpack_require__(90717);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/connectors/useHierarchicalMenu.js + 3 modules
var useHierarchicalMenu = __webpack_require__(69140);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./components/icons/light/chevron-down.svg
var chevron_down = __webpack_require__(35037);
// EXTERNAL MODULE: ./components/icons/light/chevron-up.svg
var chevron_up = __webpack_require__(11818);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(79080);
// EXTERNAL MODULE: ./components/algolia/utils.ts
var utils = __webpack_require__(93743);
;// CONCATENATED MODULE: ./components/algolia/hierarchical-menu/HierarchicalMenu.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    text-placeholder relative w-full rounded-full border bg-neutrals-0 py-3 pl-4 pr-10\n                    ",
        "\n                    ",
        "\n                  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}









function isModifierClick(event) {
    const isMiddleClick = event.button === 1;
    return Boolean(isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}
function HierarchicalList(param) {
    let { className ="" , classNames ={
        list: "",
        item: ""
    } , items , createURL , onNavigate  } = param;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
        className: "".concat(classNames.list, " [&_ul_ul_a]:pl-12"),
        children: items.map((item)=>{
            const Icon = item.isRefined ? chevron_up["default"] : chevron_down["default"];
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                        href: createURL(item.value),
                        className: "flex justify-between gap-4 py-5 pl-3 pr-2 ".concat(!item.isRefined ? "text-text-neutrals-500" : "text-text-neutrals-900", " ").concat(className),
                        onClick: (event)=>{
                            if (isModifierClick(event)) {
                                return;
                            }
                            event.preventDefault();
                            onNavigate(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-row items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                        type: "checkbox",
                                        checked: item.isRefined,
                                        readOnly: true,
                                        className: "h-4 w-4 cursor-pointer rounded-[2px] border-neutrals-500 checked:text-primary-500 checked:ring-0 focus:ring-0 focus:ring-offset-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "capitalize",
                                        children: item.label.toLowerCase()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-row items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        children: item.count
                                    }),
                                    item.canRefine && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon, {
                                        className: "h-6 w-6",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    }),
                    item.data && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HierarchicalList, {
                        items: item.data,
                        onNavigate: onNavigate,
                        createURL: createURL,
                        className: "border-b border-neutrals-50 pl-8 last:border-0",
                        classNames: {
                            list: "divide-y divide-neutrals-50"
                        }
                    })
                ]
            }, item.value);
        })
    });
}
/**
 * HierarchicalMenu
 */ const HierarchicalMenu = /*#__PURE__*/ (0,compat_module.forwardRef)((param, ref)=>{
    let { className ="" , classNames ={
        button: "",
        panel: ""
    } , ...props } = param;
    const { items , refine , createURL  } = (0,useHierarchicalMenu/* useHierarchicalMenu */.g)(props);
    const DEFAULT_VALUE = "Todos los pisos";
    const refinedValue = (0,utils/* getLastRefinedItem */.iZ)(items);
    const [zones, setZones] = (0,compat_module.useState)();
    (0,compat_module.useEffect)(()=>{
        var ref, ref1;
        if (((ref = refinedValue === null || refinedValue === void 0 ? void 0 : refinedValue.value.split(" > ")) === null || ref === void 0 ? void 0 : ref.toString()) !== ((ref1 = zones || "") === null || ref1 === void 0 ? void 0 : ref1.toString())) {
            setZones(refinedValue === null || refinedValue === void 0 ? void 0 : refinedValue.value.split(" > "));
        }
    }, [
        refinedValue
    ]);
    (0,compat_module.useEffect)(()=>{
        const province = zones === null || zones === void 0 ? void 0 : zones[0];
        const city = zones === null || zones === void 0 ? void 0 : zones[1];
        const cityArea = zones === null || zones === void 0 ? void 0 : zones[2];
        (0,helpers/* gtmPush */.De)({
            event: "parameter_filter",
            filter_action: (refinedValue === null || refinedValue === void 0 ? void 0 : refinedValue.isRefined) ? "apply_filter" : "clear_all_filter",
            filter_price_min: undefined,
            filter_price_max: undefined,
            filter_size_min: undefined,
            filter_size_max: undefined,
            filter_property_type: undefined,
            filter_property_condition: undefined,
            filter_province: province,
            filter_city: city,
            filter_city_area: cityArea,
            filter_results_count: refinedValue === null || refinedValue === void 0 ? void 0 : refinedValue.count
        });
    }, [
        zones
    ]);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(disclosure/* Disclosure */.p, {
        children: (param)=>{
            let { open , close  } = param;
            const Icon = open ? chevron_up["default"] : chevron_down["default"];
            var ref1;
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "text-body text-body--s relative ".concat(className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(disclosure/* Disclosure.Button */.p.Button, {
                        className: (0,es/* oneLine */.f9)(_templateObject(), open ? "border-neutrals-900" : "border-neutrals-500", classNames.button),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                className: "block truncate text-left font-normal",
                                children: (ref1 = refinedValue === null || refinedValue === void 0 ? void 0 : refinedValue.value) !== null && ref1 !== void 0 ? ref1 : DEFAULT_VALUE
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon, {
                                    className: "h-6 w-6",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(disclosure/* Disclosure.Panel */.p.Panel, {
                        ref: ref,
                        unmount: false,
                        className: "text-neutral-500 absolute z-10 mt-1 max-h-64 w-full min-w-[250px] overflow-auto overflow-y-scroll rounded-lg border border-neutrals-100 bg-bg-neutrals-0 p-1 shadow-light-s ".concat(classNames.panel),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HierarchicalList, {
                            items: items,
                            onNavigate: (e)=>{
                                refine(e.value);
                                close();
                            },
                            createURL: createURL,
                            className: "border-b border-neutrals-50 last:border-0",
                            classNames: {
                                list: "divide-y divide-neutrals-50"
                            }
                        })
                    })
                ]
            });
        }
    });
});
HierarchicalMenu.displayName = "HierarchicalMenu";

;// CONCATENATED MODULE: ./components/algolia/hierarchical-menu/index.ts

/* harmony default export */ var hierarchical_menu = (HierarchicalMenu);

// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/connectors/useHits.js + 4 modules
var useHits = __webpack_require__(45846);
;// CONCATENATED MODULE: ./components/algolia/title/Title.tsx


/**
 * Title
 */ const Title = (param)=>{
    let { className ="" , attributes , title , defaultArea  } = param;
    const { results  } = (0,useHits/* useHits */.O)();
    const { items  } = (0,useHierarchicalMenu/* useHierarchicalMenu */.g)({
        attributes
    });
    const getLastRefined = (items)=>{
        const item = items === null || items === void 0 ? void 0 : items.filter((item)=>item.isRefined)[0];
        if (item && item.isRefined) {
            var ref, ref1;
            const hasChildrenRefined = ((ref1 = item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : ref.filter((item)=>item.isRefined)) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
            if (hasChildrenRefined && (item === null || item === void 0 ? void 0 : item.data)) {
                return getLastRefined(item.data);
            } else {
                return item === null || item === void 0 ? void 0 : item.value;
            }
        } else {
            return defaultArea;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("h1", {
        className: "text-body text-body--m flex flex-row gap-1 font-normal ".concat(className),
        children: [
            results === null || results === void 0 ? void 0 : results.nbHits,
            " ",
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                id: "list-flats-name",
                children: title(getLastRefined(items))
            })
        ]
    });
};
Title.displayName = "Title";

;// CONCATENATED MODULE: ./components/algolia/title/index.ts

/* harmony default export */ var title = (Title);

// EXTERNAL MODULE: ./components/icons/duotone/building.svg
var building = __webpack_require__(21413);
// EXTERNAL MODULE: ./components/atoms/text/index.ts + 1 modules
var atoms_text = __webpack_require__(36558);
;// CONCATENATED MODULE: ./components/molecules/not-found/NotFound.tsx

function NotFound_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex max-w-md flex-col items-center gap-4 rounded-lg bg-primary-50 py-4 pl-2 pr-4 md:justify-center \n      ",
        "\n    "
    ]);
    NotFound_templateObject = function() {
        return data;
    };
    return data;
}



/**
 * FeaturedText
 */ const NotFound = (param)=>/*#__PURE__*/ {
    let { className ="" , Icon , children , text , subtext  } = param;
    return (0,jsx_runtime/* jsxs */.BX)("div", {
        className: (0,es/* oneLine */.f9)(NotFound_templateObject(), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon, {
                width: 64,
                height: 64,
                className: "flex-shrink-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "flex flex-col justify-between gap-4 md:w-full md:items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_text/* default */.Z, {
                        className: "text-body text-body--m text-center font-bold md:text-headline md:text-headline--h4",
                        children: text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_text/* default */.Z, {
                        className: "text-body--l mb-6 text-center",
                        children: subtext
                    }),
                    children
                ]
            })
        ]
    });
};
NotFound.displayName = "NotFound";

;// CONCATENATED MODULE: ./components/molecules/not-found/index.ts

/* harmony default export */ var not_found = (NotFound);

// EXTERNAL MODULE: ./components/molecules/grid/index.ts + 2 modules
var grid = __webpack_require__(34487);
// EXTERNAL MODULE: ./components/molecules/card-flat/index.ts + 1 modules
var card_flat = __webpack_require__(2353);
// EXTERNAL MODULE: ./lib/graphql/transformers/card.ts
var card = __webpack_require__(48193);
// EXTERNAL MODULE: ./lib/utils/utils.ts
var utils_utils = __webpack_require__(622);
;// CONCATENATED MODULE: ./components/algolia/grid-card-hits/GridCardHits.tsx









/**
 * GridCardHits
 */ const GridCardHits = (param)=>{
    let { className =""  } = param;
    const router = (0,next_router.useRouter)();
    const { hits , results  } = (0,useHits/* useHits */.O)();
    const [currentPage, setCurrentPage] = (0,compat_module.useState)(null);
    const [isFilteringDates, setIsFilteringDates] = (0,compat_module.useState)(false);
    var _hierarchicalFacetsRefinements;
    const hierarchicalZonasKeys = Object.keys((_hierarchicalFacetsRefinements = results === null || results === void 0 ? void 0 : results._state.hierarchicalFacetsRefinements) !== null && _hierarchicalFacetsRefinements !== void 0 ? _hierarchicalFacetsRefinements : {});
    (0,compat_module.useEffect)(()=>{
        const { startDate , endDate  } = router.query;
        setIsFilteringDates(startDate !== undefined || endDate !== undefined);
        if ( true && hits && results && (results.page !== currentPage || isFilteringDates)) {
            var ref, ref1, ref2;
            const listName = (ref = results === null || results === void 0 ? void 0 : results._state.hierarchicalFacetsRefinements[hierarchicalZonasKeys[0]][0]) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            (0,helpers/* gtmPush */.De)({
                event: "view_item_list",
                item_list_id: window.location.pathname,
                item_list_name: listName !== null && listName !== void 0 ? listName : "Todos los pisos",
                page_number: results === null || results === void 0 ? void 0 : results.page,
                total_page_numbers: results === null || results === void 0 ? void 0 : results.nbPages,
                // TODO: tipar correctamente
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                search_term: (ref1 = (0,utils_utils/* getQueryParams */.vl)(window.location.search)) === null || ref1 === void 0 ? void 0 : ref1.query,
                item_type: (0,utils_utils/* capitalize */.kC)(hits === null || hits === void 0 ? void 0 : (ref2 = hits[0]) === null || ref2 === void 0 ? void 0 : ref2.ventaAlquiler),
                items: hits === null || hits === void 0 ? void 0 : hits.map((hit)=>{
                    var ref;
                    return {
                        item_id: hit === null || hit === void 0 ? void 0 : hit.codigoUnidadAlquiler,
                        item_name: hit === null || hit === void 0 ? void 0 : hit.nombreUE,
                        currency: "EUR",
                        start_date: startDate ? startDate : undefined,
                        end_date: endDate ? endDate : undefined,
                        discount: undefined,
                        item_list_id: window.location.pathname,
                        item_list_name: listName !== null && listName !== void 0 ? listName : "Todos los pisos",
                        price: parseFloat(((ref = hit.ventaAlquiler) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "venta" ? hit.importeVenta : hit.importeRecibofinal)
                    };
                })
            });
            setIsFilteringDates(false);
            setCurrentPage(results === null || results === void 0 ? void 0 : results.page);
        }
    }, [
        results,
        hits
    ]);
    if (hits.length == 0) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(not_found, {
            className: "mx-auto ".concat(className),
            text: "No tenemos viviendas en esta ubicaci\xf3n",
            subtext: "Cambia o elimina algunos de los filtros o modifica el \xe1rea de b\xfasqueda.",
            Icon: building["default"]
        });
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* default */.Z, {
        xxs: 1,
        sm: 2,
        lg: 1,
        xl: 2,
        className: "gap-6 ".concat(className),
        children: hits.map((hit, key)=>{
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(grid/* default.Item */.Z.Item, {
                colSpanSM: 1,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(card_flat/* default */.Z, {
                    ...(0,card/* cardTransformer */.R)(hit, // eslint-disable-next-line @typescript-eslint/no-empty-function
                    ()=>{})
                })
            }, (ref = hit === null || hit === void 0 ? void 0 : hit.id) !== null && ref !== void 0 ? ref : key);
        })
    });
};
GridCardHits.displayName = "GridCardHits";

;// CONCATENATED MODULE: ./components/algolia/grid-card-hits/index.ts

/* harmony default export */ var grid_card_hits = (GridCardHits);

// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/connectors/usePagination.js + 3 modules
var usePagination = __webpack_require__(42650);
// EXTERNAL MODULE: ./components/molecules/pagination/index.ts + 1 modules
var pagination = __webpack_require__(58452);
;// CONCATENATED MODULE: ./components/algolia/pagination/Pagination.tsx



/**
 * Pagination
 */ const Pagination = (param)=>{
    let { className ="" , pageRangeDisplayed  } = param;
    const { nbPages , refine  } = (0,usePagination/* usePagination */.h)();
    const p = Array(nbPages).fill(null);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pagination/* default */.Z, {
        pageRangeDisplayed: pageRangeDisplayed,
        pageCount: p.length,
        className: className,
        onPageChange: (page)=>{
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            refine(page.selected);
        }
    });
};
Pagination.displayName = "Pagination";

;// CONCATENATED MODULE: ./components/algolia/pagination/index.ts

/* harmony default export */ var algolia_pagination = (Pagination);

;// CONCATENATED MODULE: ./lib/hooks/useResizeObserver.ts

const useResizeObserver = (elementRef)=>{
    const [entry, setEntry] = (0,compat_module.useState)();
    const updateEntry = (param)=>{
        let [entry] = param;
        setEntry(entry);
    };
    (0,compat_module.useEffect)(()=>{
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current; // DOM Ref
        const hasIOSupport = !!window.ResizeObserver;
        if (!hasIOSupport || !node) return;
        const observer = new ResizeObserver(updateEntry);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        elementRef
    ]);
    return entry;
};

;// CONCATENATED MODULE: ./lib/hooks/usePrevious.ts

function usePrevious(value) {
    const ref = (0,compat_module.useRef)();
    (0,compat_module.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

;// CONCATENATED MODULE: ./components/templates/list-of-flats/ListOfFlats.tsx

function ListOfFlats_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    h-full transition-all duration-300 ease-in-out\n  "
    ]);
    ListOfFlats_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  duration-400 absolute -z-10 h-10 w-10 rounded-full bg-secondary-500 transition-transform ease-out\n                  ",
        "\n                "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  mt-6 flex-shrink-0 justify-end\n                  ",
        "\n                "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  absolute top-6 left-6 z-10 flex items-center justify-center rounded-full bg-neutrals-0 text-primary-500 shadow-light-s\n                  ",
        "\n                "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

















const ClusteringMapAlgolia = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(63805), __webpack_require__.e(28714)]).then(__webpack_require__.bind(__webpack_require__, 28714)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(28714)
            ]
    },
    ssr: true
});
const Modal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(54283), __webpack_require__.e(89575)]).then(__webpack_require__.bind(__webpack_require__, 89575)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(89575)
            ]
    },
    ssr: true
});
const CalendarTabs = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(74885), __webpack_require__.e(79375), __webpack_require__.e(49296), __webpack_require__.e(54924), __webpack_require__.e(40915), __webpack_require__.e(93718)]).then(__webpack_require__.bind(__webpack_require__, 29758)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(29758)
            ]
    },
    ssr: true
});
const calculateHeight = (element)=>{
    var ref;
    if (!element) return 0;
    const height = element.offsetHeight;
    var ref1;
    const marginTop = parseInt((ref1 = (ref = window === null || window === void 0 ? void 0 : window.getComputedStyle(element)) === null || ref === void 0 ? void 0 : ref.getPropertyValue("margin-top")) !== null && ref1 !== void 0 ? ref1 : 0);
    // Este es el height del box shadow del Disclosure.Panel del HierarchicalMenu
    const BOX_SHADOW_HEIGHT = 12;
    return height + marginTop + BOX_SHADOW_HEIGHT;
};
const isMedEst = (type)=>type === "MED_EST";
/**
 * ListOfFlats
 */ const ListOfFlats = (param)=>{
    let { minBookingDays , serverState , type , defaultArea , typeText , initialUiState  } = param;
    const router = (0,next_router.useRouter)();
    const [mapFull, setMapFull] = (0,compat_module.useState)(false);
    const [dates, setDates] = (0,compat_module.useState)([]);
    const [openDateFilter, setOpenDateFilter] = (0,compat_module.useState)(false);
    const filterRef = (0,compat_module.useRef)(null);
    const prevAmount = usePrevious(mapFull);
    const entry = useResizeObserver(filterRef);
    const mapClasses = (0,es/* oneLine */.f9)(ListOfFlats_templateObject(), mapFull ? "w-full aspect-[3/4] md:aspect-video" : "min-w-[550px] aspect-[3/4] hidden lg:flex");
    (0,compat_module.useEffect)(()=>{
        if (prevAmount !== undefined) {
            (0,helpers/* gtmPush */.De)({
                event: "map_interaction",
                map_action: mapFull ? "open" : "close"
            });
        }
    }, [
        mapFull
    ]);
    var _NEXT_PUBLIC_ALGOLIA_SEARCH_FLATS_INDEX_NAME;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            isMedEst(type) && minBookingDays && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                isOpen: openDateFilter,
                closeModal: ()=>setOpenDateFilter(false),
                unmount: true,
                className: "md:w-[710px]",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalendarTabs, {
                    minDays: minBookingDays,
                    onSubmit: async (values)=>{
                        await router.replace({
                            query: {
                                ...router.query,
                                startDate: values.startDate.format("DD-MM-YYYY"),
                                endDate: values.endDate.format("DD-MM-YYYY")
                            }
                        });
                        setDates([
                            values.startDate,
                            values.endDate
                        ]);
                        setOpenDateFilter(false);
                    },
                    onReset: ()=>setDates([]),
                    message: "Estancia m\xednima ".concat(minBookingDays, " d\xedas")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstantSearchSSRProvider/* InstantSearchSSRProvider */.H, {
                ...serverState ? serverState : {},
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(instant_search["default"], {
                    indexName: (_NEXT_PUBLIC_ALGOLIA_SEARCH_FLATS_INDEX_NAME = "development_api::zfm-disponiblidad.zfm-disponiblidad") !== null && _NEXT_PUBLIC_ALGOLIA_SEARCH_FLATS_INDEX_NAME !== void 0 ? _NEXT_PUBLIC_ALGOLIA_SEARCH_FLATS_INDEX_NAME : "",
                    ...initialUiState && {
                        initialUiState
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Configure/* Configure */.T, {
                            hitsPerPage: 8,
                            filters: "tipoDeUsoDescription:Vivienda AND ventaAlquiler:".concat(type),
                            ...isMedEst(type) && dates.length === 2 && {
                                numericFilters: [
                                    "fechaDisponibleDesde <= ".concat(dates[0].unix()),
                                    "fechaDisponibleHasta >= ".concat(dates[1].unix())
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(container/* default */.Z, {
                            wrapper: true,
                            padding: "",
                            className: "scrollbar-hide z-10 overflow-x-auto pt-4",
                            // Modo tricky para mostrar select en mobile con overflow-x-auto habría que cambiarlo a un modal los select
                            style: {
                                marginBottom: "-".concat(calculateHeight(entry === null || entry === void 0 ? void 0 : entry.target), "px"),
                                paddingBottom: "".concat(calculateHeight(entry === null || entry === void 0 ? void 0 : entry.target), "px")
                            },
                            classNameWrapper: "!flex-row lg:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "relative order-2 ml-1.5 flex flex-row gap-2 border-l border-neutrals-200 pl-1.5 pr-3 lg:order-1 lg:ml-0 lg:gap-4 lg:border-none lg:pl-0 lg:pr-0",
                                    children: [
                                        isMedEst(type) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                                            onClick: async ()=>{
                                                if (dates.length === 0) {
                                                    setOpenDateFilter(true);
                                                } else {
                                                    await router.replace({
                                                        query: {}
                                                    });
                                                    setDates([]);
                                                }
                                            },
                                            className: "inline-flex w-max items-center justify-center gap-1.5 rounded-full border border-neutrals-500 py-3 px-4 font-normal",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(calendar["default"], {
                                                    className: "h-4 w-4"
                                                }),
                                                dates.length === 0 ? "Disponibilidad" : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                    children: [
                                                        "Del ",
                                                        dates[0].format("DD/MM/YYYY"),
                                                        " al",
                                                        " ",
                                                        dates[1].format("DD/MM/YYYY"),
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(x["default"], {
                                                            className: "h-4 w-4"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(hierarchical_menu, {
                                            ref: filterRef,
                                            attributes: [
                                                "hierarchicalZonas.lvl0",
                                                "hierarchicalZonas.lvl1",
                                                "hierarchicalZonas.lvl2"
                                            ],
                                            classNames: {
                                                button: "md:max-w-max",
                                                panel: "md:max-w-max md:min-w-[330px]"
                                            },
                                            sortBy: [
                                                "isRefined"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "relative order-1 ml-3 flex flex-row items-center justify-between rounded-full border border-neutrals-200 p-1 lg:order-2 lg:ml-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: (0,es/* oneLine */.f9)(_templateObject1(), !mapFull ? "translate-x-10" : "")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                                            onClick: ()=>setMapFull(!mapFull),
                                            className: "flex h-10 w-10 items-center justify-center rounded-full text-text-neutrals-900",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(map_pin["default"], {
                                                className: "h-4 w-4"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                                            onClick: ()=>setMapFull(!mapFull),
                                            className: "flex h-10 w-10 items-center justify-center rounded-full text-text-neutrals-900",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(list["default"], {
                                                className: "h-4 w-4"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(container/* default */.Z, {
                            wrapper: true,
                            classNameWrapper: "lg:!flex-row gap-4 lg:gap-6",
                            className: "mt-4 border-t border-neutrals-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: mapFull ? "lg:hidden" : "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(title, {
                                            title: (currentArea)=>"Pisos ".concat(typeText, " en ").concat(currentArea),
                                            defaultArea: defaultArea,
                                            attributes: [
                                                "hierarchicalZonas.lvl0",
                                                "hierarchicalZonas.lvl1",
                                                "hierarchicalZonas.lvl2"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid_card_hits, {
                                            className: mapFull ? "hidden lg:block" : "mt-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(algolia_pagination, {
                                            className: (0,es/* oneLine */.f9)(_templateObject2(), mapFull ? "hidden lg:block" : "")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "".concat(mapClasses, " sticky top-6 overflow-hidden rounded-lg"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                                            className: (0,es/* oneLine */.f9)(_templateObject3(), mapFull ? "" : "h-10 w-10"),
                                            onClick: ()=>setMapFull(!mapFull),
                                            children: mapFull ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                className: "flex flex-row gap-3 py-2.5 pl-4 pr-2 text-text-neutrals-900",
                                                children: [
                                                    "Ver listado",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_right["default"], {
                                                        className: "h-6 w-6 text-primary-500"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_left["default"], {
                                                className: "h-6 w-6"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ClusteringMapAlgolia, {
                                            className: mapClasses
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
ListOfFlats.displayName = "ListOfFlats";

;// CONCATENATED MODULE: ./components/templates/list-of-flats/index.ts

/* harmony default export */ var list_of_flats = (ListOfFlats);


/***/ })

}]);